import getIsChrome from "selectors/device/getIsChrome";
import getIsDesktop from "selectors/device/getIsDesktop";
import getUserAgent from "selectors/device/getUserAgent";

import { createSelector } from "reselect";

export default createSelector(
  getIsChrome,
  getIsDesktop,
  getUserAgent,
  (isChrome, isDesktop, userAgent) => isChrome && isDesktop && userAgent.isMac,
);
